import { render, staticRenderFns } from "./SocialSectionInstagramItem.vue?vue&type=template&id=46e55921"
import script from "./SocialSectionInstagramItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SocialSectionInstagramItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports